import * as React from 'react';

type IconProps = React.SVGProps<SVGSVGElement> & { d?: string; size?: number; strokeWidth?: number };

export const Icon = ({ d, size = 20, strokeWidth = 1.7, ...p }: IconProps) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" {...p}
  >
    <path d={d} />
  </svg>
);

export const ArrowIcon = (p: IconProps) => <Icon {...p} d="M5 12h14M13 6l6 6-6 6" />;
export const ChartIcon = (p: IconProps) => <Icon {...p} d="M4 20V10M10 20V4M16 20v-7M22 20H2" />;
export const BoltIcon = (p: IconProps) => <Icon {...p} d="M13 2L4 14h6l-1 8 9-12h-6z" />;
export const LayersIcon = (p: IconProps) => <Icon {...p} d="M12 3l9 5-9 5-9-5 9-5zM3 13l9 5 9-5" />;
export const ChevronDownIcon = (p: IconProps) => <Icon {...p} d="M6 9l6 6 6-6" />;

/* globe: circle + equator + the meridian curve that reads as a sphere at 16px */
export const GlobeIcon = ({ size = 20, strokeWidth = 1.7, ...p }: IconProps) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...p}
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c2.5 2.5 2.5 15 0 18-2.5-3-2.5-15.5 0-18z" />
  </svg>
);

/* filled play triangle (nav "watch demo" glyph) — fill, not stroke, so it reads at small size */
export const PlayIcon = ({ size = 14, ...p }: React.SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M8 5v14l11-7z" />
  </svg>
);

/* brand marks, filled so they stay legible at 18px */
export const LinkedInIcon = ({ size = 18, ...p }: React.SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" />
  </svg>
);

export const InstagramIcon = ({ size = 18, ...p }: React.SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...p}
  >
    <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" />
    <circle cx="12" cy="12" r="4.2" />
    <circle cx="17.4" cy="6.6" r="0.6" fill="currentColor" />
  </svg>
);
